import React from "react"

import { colors } from "@bullseye/tailwind-config"

import { IconProps } from "./IconProps"

const CheckIcon: React.FC<IconProps> = ({
  scale = 1,
  lineScale = 1,
  color = colors.green[800],
}) => (
  <svg
    viewBox="0 0 24 24"
    width={scale * 24}
    height={scale * 24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Check"
  >
    <path
      d="M20 6L9 17L4 12"
      stroke={color}
      strokeWidth={lineScale * 2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CheckIcon
